/**
 * Service blocks data configuration for AllServicesPage
 * This file contains all the content for the service detail sections
 */

export const serviceBlocksData = [
  {
    id: 'realestate-fund',
    number: '01',
    title: 'Fund: "AAC Real Estate I"',
    subtitle: 'Creating New Housing in Spain',
    description: 'Ethical real estate investment. We renovate undervalued properties in affordable areas, solving the housing shortage while delivering high yields. Fully backed by real assets.',
    bulletPoints: [
      'Target: 15-40% annualized returns',
      '100% backed by real assets',
      'Fiat, Crypto & Cash accepted'
    ],
    cta: { text: 'Learn More', href: '/realestate', external: false },
    ctaInvest: { text: 'Invest Now', href: 'https://wa.me/34633905071?text=Hi,%20I%27m%20interested%20in%20AAC%20Real%20Estate%20I%20fund', external: true },
    image: { 
      src: 'https://customer-assets.emergentagent.com/job_98176c5a-4141-45aa-866d-b1c1a8cb31e7/artifacts/v6t9afwt_7a40f4_b4ea21305c7748ec9f8397d8456570c4~mv2.avif',
      alt: 'AAC Real Estate',
      isCard: false
    },
    accentColor: 'yellow',
    bgColor: 'dark',
    imageLeft: false
  },
  {
    id: 'quant-fund',
    number: '02',
    title: 'Fund: "AAC Quantitative DAO"',
    subtitle: 'Algorithmic Trading · Forex, Gold & Crypto',
    description: 'Systematic trading strategy with verified results. Top 1% trader rankings on multiple prop firms. Professional execution across Forex and Blockchain markets.',
    bulletPoints: [
      'Target: 20-25% APY',
      'Verified track record',
      'Forex, Gold & Blockchain'
    ],
    cta: { text: 'Learn More', href: '/quantitative', external: false },
    ctaInvest: { text: 'Invest Now', href: 'https://wa.me/34633905071?text=Hi,%20I%27m%20interested%20in%20AAC%20Quantitative%20DAO%20fund', external: true },
    image: { 
      src: 'https://static.wixstatic.com/media/7a40f4_ee889582a7c84970981afa258d79a0b7~mv2.jpg',
      alt: 'AAC Quantitative Trading',
      isCard: false
    },
    accentColor: 'cyan',
    bgColor: 'light',
    imageLeft: true
  },
  {
    id: 'crypto',
    number: '03',
    title: 'Crypto OTC & Lending',
    subtitle: 'High Volume BTC/USDT',
    description: 'Large volume OTC trades with competitive rates. Collateralized loans against crypto holdings. Fast execution with trusted counterparties.',
    bulletPoints: [
      'High volume BTC/USDT trades',
      'Collateralized crypto loans',
      'Competitive OTC rates'
    ],
    cta: { text: 'Contact via Telegram', href: 'https://t.me/+gbLD_8i3AbIzMTY0', external: true, icon: 'send' },
    image: {
      src: 'https://static.wixstatic.com/media/7a40f4_ea692eea04ec45729182fee25b746408~mv2.webp',
      alt: 'Crypto Trading'
    },
    accentColor: 'purple',
    bgColor: 'dark',
    imageLeft: false
  },
  {
    id: 'tax',
    number: '04',
    title: 'Tax Optimization & Structures',
    subtitle: 'LLCs, Dubai, Offshore',
    description: 'Legal tax optimization through proper corporate structures. From US LLCs to Dubai company formation. Special focus on digital entrepreneurs and content creators.',
    bulletPoints: [
      'US LLCs Formation & Advisory',
      'Dubai Company Formation',
      "Spain's Holding Structures, Tax Optimization & Strategies"
    ],
    extraContent: 'tax-structures',
    cta: { text: 'Get Consultation', href: 'https://t.me/+gbLD_8i3AbIzMTY0', external: true },
    image: {
      src: 'https://images.unsplash.com/photo-1695413483115-710edb7924ba?w=800&q=80',
      alt: 'Dubai Business'
    },
    accentColor: 'purple',
    bgColor: 'light',
    imageLeft: true
  },
  {
    id: 'offmarket',
    number: '05',
    title: 'Off-Market Real Estate',
    subtitle: 'Hotels, Villas, Marbella...',
    description: 'Direct access to exclusive off-market properties through our network of owners and developers. From luxury villas in Marbella to hotel investments globally.',
    bulletPoints: [
      'Luxury Villas & Beach Clubs',
      'Hotels & Hospitality Assets',
      '100% Confidential Transactions'
    ],
    cta: { text: 'Request Access', href: 'https://t.me/+gbLD_8i3AbIzMTY0', external: true },
    image: { 
      src: 'https://static.wixstatic.com/media/7a40f4_b0c9d423abf74b199e3fc5498a37a20d~mv2.jpg',
      alt: 'Luxury Villa'
    },
    accentColor: 'yellow',
    bgColor: 'dark',
    imageLeft: false
  },
  {
    id: 'gold',
    number: '06',
    title: 'Gold & Crypto P2P',
    subtitle: 'Physical & Digital Operations',
    description: 'Physical gold sourcing and peer-to-peer crypto transactions. Flexible operations for both traditional and digital assets.',
    bulletPoints: [
      'Physical Gold Sourcing',
      'Crypto P2P Transactions',
      'Flexible Payment Options'
    ],
    cta: { text: 'Inquire', href: 'https://t.me/+gbLD_8i3AbIzMTY0', external: true },
    image: {
      src: 'https://images.unsplash.com/photo-1610375461246-83df859d849d?w=800&q=80',
      alt: 'Gold Bars Investment'
    },
    accentColor: 'yellow',
    bgColor: 'light',
    imageLeft: true
  },
  {
    id: 'supercars',
    number: '07',
    title: 'Dubai Supercar Exports',
    subtitle: 'Up to 50% Less',
    description: 'Partner service for sourcing and exporting premium vehicles from Dubai. Due to tax advantages and market conditions, prices are significantly more accessible than European markets.',
    bulletPoints: [
      'Premium & Exotic Vehicles',
      'Up to 50% Less Than Europe',
      'Full Export Service'
    ],
    cta: { text: 'Inquire', href: 'https://t.me/+gbLD_8i3AbIzMTY0', external: true },
    image: {
      src: 'https://images.unsplash.com/photo-1544636331-e26879cd4d9b?w=800&q=80',
      alt: 'Luxury Supercar'
    },
    accentColor: 'yellow',
    bgColor: 'dark',
    imageLeft: false
  },
  {
    id: 'yachts',
    number: '08',
    title: 'Yachts & Superyachts',
    subtitle: 'Sales & Charter',
    description: 'Access to yacht sales and charter opportunities through our network. From day charters to superyacht acquisitions.',
    bulletPoints: [
      'Yacht Sales & Brokerage',
      'Charter Services',
      'Superyacht Access'
    ],
    cta: { text: 'Inquire', href: 'https://t.me/+gbLD_8i3AbIzMTY0', external: true },
    image: {
      src: 'https://images.unsplash.com/photo-1567899378494-47b22a2ae96a?w=800&q=80',
      alt: 'Luxury Yacht'
    },
    accentColor: 'yellow',
    bgColor: 'light',
    imageLeft: true
  },
  {
    id: 'watches',
    number: '09',
    title: 'Luxury Watches',
    subtitle: 'Crypto/Cash Sourcing',
    description: 'Sourcing of luxury timepieces with flexible payment options. Rolex, Patek Philippe, Audemars Piguet and more.',
    bulletPoints: [
      'Premium Watch Sourcing',
      'Bank, Cash & Crypto Accepted',
      'Verified Authenticity'
    ],
    cta: { text: 'Inquire', href: 'https://t.me/+gbLD_8i3AbIzMTY0', external: true },
    image: {
      src: 'https://images.unsplash.com/photo-1638872726444-0579101a60e7?w=800&q=80',
      alt: 'Audemars Piguet Royal Oak'
    },
    accentColor: 'yellow',
    bgColor: 'dark',
    imageLeft: false
  },
  {
    id: 'art',
    number: '10',
    title: 'Spanish Fine Art',
    subtitle: 'Goya, Sorolla & Masters',
    description: 'Access to fine art deals through our network of collectors and galleries. Specializing in Spanish masters and Old Master paintings.',
    bulletPoints: [
      'Spanish Masters (Goya, Sorolla)',
      'Old Master Paintings',
      'Investment Grade Art'
    ],
    cta: { text: 'Inquire', href: 'https://t.me/+gbLD_8i3AbIzMTY0', external: true },
    image: {
      src: 'https://customer-assets.emergentagent.com/job_972a2ae2-9c5a-40a4-b89e-5ecb188d7363/artifacts/mujyadyu_sorolla.jpg',
      alt: 'Sorolla Painting'
    },
    accentColor: 'yellow',
    bgColor: 'light',
    imageLeft: true
  }
];

// Custom image content components mapping
export const customImageComponents = {
  otc: (
    <div className="bg-gradient-to-br from-purple-900/30 to-gray-900 rounded-xl p-8 border border-purple-500/20 text-center">
      <p className="text-6xl font-bold text-white mb-2">OTC</p>
      <p className="text-purple-400">Large Volume Trades</p>
    </div>
  ),
  tax: (
    <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-xl p-8 border border-gray-700">
      <p className="text-sm text-gray-500 mb-4">STRUCTURES AVAILABLE</p>
      <ul className="space-y-3">
        <li className="text-white font-medium">🇺🇸 US LLCs (Wyoming, Delaware)</li>
        <li className="text-white font-medium">🇦🇪 Dubai Company Formation</li>
        <li className="text-white font-medium">🇪🇸 Spanish Holding Structures</li>
        <li className="text-white font-medium">🌍 International Tax Planning</li>
      </ul>
    </div>
  ),
  gold: (
    <div className="bg-gradient-to-br from-yellow-900/30 to-gray-900 rounded-xl p-8 border border-yellow-500/20 text-center">
      <p className="text-6xl mb-2">🥇</p>
      <p className="text-yellow-400">Physical & Digital</p>
    </div>
  ),
  supercars: (
    <div className="bg-gradient-to-br from-red-900/30 to-gray-900 rounded-xl p-8 border border-red-500/20 text-center">
      <p className="text-6xl mb-2">🏎️</p>
      <p className="text-red-400">Dubai = Affordable</p>
    </div>
  ),
  yachts: (
    <div className="bg-gradient-to-br from-blue-900/30 to-gray-900 rounded-xl p-8 border border-blue-500/20 text-center">
      <p className="text-6xl mb-2">🛥️</p>
      <p className="text-blue-400">Sales & Charter</p>
    </div>
  ),
  watches: (
    <div className="bg-gradient-to-br from-yellow-900/30 to-gray-900 rounded-xl p-8 border border-yellow-500/20 text-center">
      <p className="text-6xl mb-2">⌚</p>
      <p className="text-yellow-400">Luxury Timepieces</p>
    </div>
  ),
  art: (
    <div className="bg-gradient-to-br from-amber-900/30 to-gray-900 rounded-xl p-8 border border-amber-500/20 text-center">
      <p className="text-6xl mb-2">🎨</p>
      <p className="text-amber-400">Old Masters & Spanish Art</p>
    </div>
  )
};
